export default "__VITE_ASSET__CKKywsew__"